import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
import {
  Card,
  CardTitle,
  CardActions,
} from 'material-ui/Card';
import { darkBlack } from 'material-ui/styles/colors';
import { Link } from 'react-router-dom';
import Radium from 'radium';
import CloneReportMutation from '../../../../../../mutations/CloneReportMutation';


const styles = {
  reportLink: {
    textDecoration: 'none',
  },
  reportItem: {
    minHeight: 120,
  },
  reportTitle: {
    color: darkBlack,
    userSelect: 'none',
  },
};

@withRouter
@Radium
class ReportListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zDepth: 1,
      disableCloneButton: false,
    };
  }

  onMouseOver = () => this.setState({ zDepth: 3 });
  onMouseOut = () => this.setState({ zDepth: 1 });
  onMouseDown = () => this.setState({ zDepth: 2 });
  onMouseUp = () => this.setState({ zDepth: 3 });

  /**
   * Clone report
   */
  clone = () => {
    this.setState({ disableCloneButton: true });
    CloneReportMutation.commit({
      id: this.props.report.id,
    },
      (err, data) => {
        this.setState({ disableCloneButton: false })
      });
  };

  render() {
    return (
      <Link
        to={`/reports/${this.props.report.id}${this.props.location.search}`}
        style={styles.reportLink}
      >
        <Card
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          onMouseDown={this.onMouseDown}
          onMouseUp={this.onMouseUp}
          zDepth={this.state.zDepth}
          style={styles.reportItem}
        >
          <CardTitle
            title={this.props.report.name}
            titleStyle={styles.reportTitle}
          />
          {!!this.props.isAccountAdmin &&
            <CardActions>
              <div
                style={{
                  textAlign: 'right',
                }}
              >
                <button
                  style={{
                    cursor: 'pointer',
                    zIndex: 9999,
                    backgroundColor: 'transparent',
                    borderRadius: '2px',
                    border: '1px solid #00abc5',
                    color: '#00abc5',
                    padding: '4px 8px',
                    textTransform: 'uppercase',
                    fontSize: '85%',
                  }}
                  disabled={this.state.disableCloneButton}
                  onClick={($event) => {
                    $event.preventDefault();
                    this.clone();
                  }}
                >
                  Clone
                </button>
              </div>
            </CardActions>}
        </Card>
      </Link>
    );
  }
}

export default createFragmentContainer(
  ReportListItem,
  graphql`
    fragment ReportListItem_report on Report {
      id
      name
    }
  `,
);



// WEBPACK FOOTER //
// ./src/scenes/Reports/components/ReportList/components/ReportListItem/ReportListItem.js